module.exports = "<img class=\"blur\"\n     id=\"blur\"\n     ng-src=\"{{blur}}\" />\n<img class=\"img-hide\"\n     id=\"image\"\n     ng-src=\"{{image}}\" />\n"


//////////////////
// WEBPACK FOOTER
// ./client/components/directives/lazyLoad/lazyLoad.html
// module id = 132
// module chunks = 0